import { RELEASE_HISTORY_CRITICAL_CHANGES, RELEASE_HISTORY_VERSIONS } from 'constants/requestUrls';
import mainApi from 'store/apis/mainApi';

import type IBaseQueryResponse from 'store/types/IBaseQueryResponse';
import type ICriticalChange from '../interfaces/ICriticalChange';
import type ICriticalChangesRequest from '../interfaces/ICriticalChangesRequest';
import type IReleaseVersion from '../interfaces/IReleaseVersion';

export const releaseHistoryApi = mainApi.injectEndpoints({
  endpoints: (build) => ({
    getReleaseVersions: build.query<IBaseQueryResponse<IReleaseVersion[]>, void>({
      query: () => ({
        url: RELEASE_HISTORY_VERSIONS,
      }),
    }),
    getCriticalChanges: build.query<IBaseQueryResponse<ICriticalChange[]>, ICriticalChangesRequest>({
      query: ({ from, to }) => ({
        url: RELEASE_HISTORY_CRITICAL_CHANGES,
        params: { from, to },
      }),
    }),
  }),
});

export const {
  useGetCriticalChangesQuery,
  useGetReleaseVersionsQuery,
} = releaseHistoryApi;
